// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2uK7z","additionalInfo":"AgreementModal_additionalInfo__2agvA"};